import * as React from 'react';
import cx from 'classnames';
import Link from '@src/components/link';
import wrapStore from '@src/utils/wrap-store';
import FloatRightStore from './store';
import styles from './index.less';

const FloatRight = ({ store }) => {
  store.use();
  return (
    <div className={cx(styles.root, store.showFloat && styles.showFloat)}>
      <Link
        className={cx(styles.close, !store.open && styles.open)}
        onClick={() => {
          store.openClose();
        }}
      />
      {store.type === 1 ? (
        <div className={cx(styles.float, !store.open && styles.close_float)} data-name="下载">
          <div className={styles.float_title} />
          <div className={styles.qrcode} key={store.FloatQrcode}>
            {store.FloatQrcode && <iframe src={store.FloatQrcode} title="侧边栏扫码下载" />}
            {/* <img src={require('./images/qrcode.png')} alt="" /> */}
          </div>
          <div className={styles.btns}>
            <Link className={cx(styles.btn, styles.android)} onClick={() => store.handleDownload('android')} />
            <Link className={cx(styles.btn, styles.ios)} onClick={() => store.handleDownload('apple')} />
            <Link href="https://jxqy.seasungames.cn/index/index.html" target="_blank" className={cx(styles.btn, styles.web)} onClick={() => store.gotoWeb()} />
            <Link href="https://support.seasungames.cn/product/jxsjl" target="_blank" className={cx(styles.btn, styles.kf)} onClick={() => store.gotokF()} />
          </div>
        </div>
      ) : (
        <div className={cx(styles.float, styles.appointment, !store.open && styles.close_float)} data-name="预约">
          <div className={styles.qrcode}>
            <img src={require('./images/qrcode-app.jpg')} alt="" />
          </div>
          <div className={styles.app_text}>
            <div className={styles.app_text_icon} />
          </div>
          <div className={styles.btns}>
            <div className={cx(styles.btn, styles.wxgzh)}>
              <div className={styles.wxgzh_text}>
                <img src={require('./images/qrcode-wxgzh.png')} alt="" />
              </div>
            </div>
            <div className={cx(styles.btn, styles.wxgj)}>
              <div className={styles.wxgzh_text}>
                <img src={require('./images/qrcode-wxgj.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default wrapStore(FloatRight, FloatRightStore);
